/**
 * What we say to a student whose microphone is delivering silence.
 *
 * Two screens say it — the device check before an assessment, and the nudge
 * during a Socratic dialogue. Kept together so the wording stays the same on
 * both, and so the one thing that differs between them stays deliberate: the
 * device check has a microphone picker on screen and can send the student to it,
 * the dialogue does not.
 */

export const CANT_HEAR_TITLE = "We can’t hear you";

/** Mid-dialogue, where there is nothing to change but the computer's settings. */
export const CANT_HEAR_FIXES =
  "Check your computer isn’t muted and the input volume is turned up.";

/** On the device check, where the picker sits directly below the message. */
export const CANT_HEAR_FIXES_WITH_PICKER =
  "Check your computer isn’t muted, the input volume is turned up, and the " +
  "right microphone is selected below.";
